module.exports = __webpack_public_path__ + "static/media/loading.d4e02155.svg";